import React from 'react';
//import Header from './Header.js';
import Disclaimers from './Disclaimers.js';

import CardMedia from '@material-ui/core/CardMedia';
import { makeStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import Box from '@material-ui/core/Box';

import Link from '@material-ui/core/Link';

//import logo_shield from './fantes_md_shield.svg';
import profile_pic from './ff_profile_pic.png';


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
      padding: 20,
      paddingTop:100,
      margin: 'auto',
      maxWidth: 800,
  },
  card: {
    //padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
      //margin: theme.spacing(2),
      alignItems: 'center',
  }, 
  text: {
    textAlign: "justify",
    padding: theme.spacing(2),
    margin: theme.spacing(2),
  },
    media: {
        width: 100,
        borderRadius: 100,
    },
    cardContent: {
        paddingTop: theme.spacing(0),
        paddintBottom: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1),
      margin: theme.spacing(0),
    },
    cardText: {
        color: theme.palette.text.secondary,
        textAlign: 'left',
        alignItems: 'left',
      },
      header1: {
        fontSize: 32,
      },
      header2: {
        fontSize: 22,
      },
}));

export default function AboutMe (props) {
    const classes = useStyles();
    return <>
            <div className={classes.root}>
            <Grid container spacing={3}>
                <Grid item>
                    <Box className={classes.card}>
                        <CardMedia className={classes.media} image={profile_pic} component="img" alt="profile" />
                    </Box>
                </Grid>
                <Grid item xs={8}>
                    <Box className={classes.cardText}> 
                        <Typography className={classes.header1} variant="h1" color="inherit"><strong>About The Developer</strong></Typography> 
                    </Box>
                    <Box className={classes.cardText}>
                        <Typography className={classes.header2}  variant="h2" color="inherit">Francisco Fantes, MD, MSc</Typography> 
                    </Box>
                </Grid>
            </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Box>
                            <Typography className={classes.text} color="inherit">Francisco Fantes, MD, MSc (pronouns he/him/his) is a board-certified, Harvard-trained psychiatrist working in Boston, MA at <Link href="https://fenwayhealth.org/" target="_blank">Fenway Health</Link> (a community health clinic which specializes in treating LGBTQ+ and underserved populations). Dr. Fantes is a Harvard Medical School lecturer in psychiatry. His primary specialties are psychopharmacology, LGBTQ+ mental health and Latino mental health. 
                            <br /> <br />
                            Dr. Fantes began coding for fun by self-teaching QBasic, HTML, then C++ in young adulthood. He has been an amateur coding enthusiast since then and enjoys continuing to work on programming skills during his free time. He continues to be interested in the intersection of medicine, psychiatry and technology. 
                            <br /><br />
                            He developed this website as he felt there was a need for these "apps" in his own practice--as well as to take advantage of his interest in programming. <em><strong>The aim of this site is not only to make it easy to fill out surveys/logs, but to also make it easy to share these results with your provider (through user-friendly PDFs).</strong></em>
                            <br /><br />
                            Dr. Fantes also developed a <Link href="https://med-billing.web.app/" target="_blank">Medical Billing Calculator</Link> to help physicians calculate the correct billing codes for outpatient services after the 2021 AMA updates.
                            <br /><br />
                            This site was developed with Javascript and <Link href="https://reactjs.org/" target="_blank">ReactJS</Link>. Hosted on Google's <Link href="https://firebase.google.com/" target="_blank">Firebase</Link>. User-interface created with <Link href="https://material-ui.com/" target="_blank">Material-UI</Link>. API for PDF creation site through <Link href="https://react-pdf.org/" target="_blank">React-PDF</Link>. API for CSV file creation through <Link href="https://www.npmjs.com/package/react-csv" target="_blank">React-CSV</Link>. Graphing user-interface functionality developed with <Link href="https://formidable.com/open-source/victory/" target="_blank">Victory Chart</Link>. Tools for Google Firebase Firestore from <Link href="https://www.npmjs.com/package/react-firebase-hooks" target="_blank">React Firebase Hooks</Link>. Logo created with <Link href="https://www.syniumsoftware.com/logoist" target="_blank">Logoist</Link>.</Typography>
                        </Box>
                    </Grid>
                </Grid>
                <Disclaimers />
            </div>
        </>;
}